import { Box, makeStyles, Typography } from '@material-ui/core';
import { colors } from 'design-system';

const useStyle = makeStyles(() => ({
  textGray: {
    fontSize: 15,
    fontWeight: 500,
  },
  textValue: {
    color: '#4A4B4E',
    fontSize: 17,
    fontWeight: 400,
  },
  tooltipRoot: {
    maxWidth: 130,
    color: colors.madison,
    backgroundColor: 'white',
    fontSize: 13,
    fontWeigh: 500,
    border: '1px solid #00',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.05)',
  },
  tooltipArrow: {
    color: 'white',
  },
}));

type Props = {
  description: string;
  value: string;
  showHelper: boolean;
  helperText: string;
};

const InformationRow = ({
  description,
  value,
  helperText,
  showHelper,
}: Props): JSX.Element => {
  const classes = useStyle();
  return (
    <Box display="flex" flexDirection="column" data-testid="information-row">
      <Box
        display="flex"
        justifyContent="space-between"
        style={{ gap: '0.5rem' }}
      >
        <Typography
          variant="caption"
          className={classes.textGray}
          data-testid="description-text"
        >
          {description}
        </Typography>
        <Typography
          className={classes.textValue}
          variant="body2"
          data-testid="value-text"
          align="right"
        >
          {value}
        </Typography>
      </Box>
      {showHelper && (
        <Typography
          variant="body2"
          data-testid="helper-text"
          align="right"
          style={{ fontWeight: 400, fontSize: 13, color: '#A3A2A2' }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default InformationRow;
